import { render, staticRenderFns } from "./purchase-dialog.vue?vue&type=template&id=6bbb54b2&scoped=true&"
import script from "./purchase-dialog.vue?vue&type=script&lang=js&"
export * from "./purchase-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbb54b2",
  null
  
)

export default component.exports